import { ampli, WalletConnectClickedProperties } from '@/ampli';

import { useWalletConnectionModal } from '@/hooks/useWalletConnectionModal';

import { AppConnectButton } from '../Header/HeaderButtons';

export const ConnectEthereumWalletButton = ({
  source,
}: {
  source?: WalletConnectClickedProperties['source'];
}): React.ReactElement => {
  const { startConnectFlow } = useWalletConnectionModal();

  const handleConnectClick = (): void => {
    if (source) {
      ampli.walletConnectClicked({ source, ui_location: source });
    }
    startConnectFlow({ source: source ?? 'primary_button' });
  };

  return <AppConnectButton onClick={handleConnectClick}>Connect EVM Wallet</AppConnectButton>;
};
